import { Site } from '@envato/foundation-types'
import * as React from 'react'
import Helmet from 'react-helmet'

import { config } from '../../../common/config'
import siteConfigs from '../../../config/sites'

interface IProps {
  seoMeta: any
  location: any
  currentSite: Site
  noIndex: boolean
  baseUrl: string
  canonicalPath: string
  menuConfig?: any
}

export default ({
  seoMeta,
  currentSite,
  noIndex,
  baseUrl,
  canonicalPath,
  menuConfig
}: IProps) => {
  const title = seoMeta.title || ''
  const description = seoMeta.meta_description || seoMeta.description || ''
  const siteConfig = siteConfigs[currentSite]

  // Defining meta tags
  const meta = [
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description }
  ]

  // set no index header
  if (noIndex) {
    meta.push({ name: 'robots', content: 'noindex' })
  }

  meta.push({ property: 'og:url', content: baseUrl + canonicalPath })
  // Defining link tags
  const link: Array<React.AnchorHTMLAttributes<HTMLAnchorElement>> = [
    { rel: 'canonical', href: baseUrl + canonicalPath }
  ]

  // Define extra scripts
  const script = [
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "http://schema.org",
        "@type": "WebSite",
        "name": "${siteConfig.name}",
        "url": "${baseUrl}"
      }`
    },
    {
      type: 'application/ld+json',
      innerHTML: `{
        "@context": "http://schema.org",
        "@type": "Organization",
        "name": "${siteConfig.name}",
        "url": "${baseUrl}",
        "sameAs": [
          "https://www.facebook.com/envatomarket/",
          "https://twitter.com/envatomarket/",
          "https://www.youtube.com/user/Envato/",
          "https://www.instagram.com/envato/",
          "https://www.pinterest.com/envato/"
        ],
        "logo": "${
          config.assets.PUBLIC_PATH
        }/images/logo-envato-market-black.svg"
      }`
    }
  ]

  return (
    <Helmet
      title={title}
      defaultTitle="Envato Market"
      meta={meta}
      link={link}
      script={script}
    />
  )
}
